import {Component, Input, OnInit} from '@angular/core';
import {EiStructureFieldBaseComponent} from "../ei-structure-field-base.component";
import {EiStructureFieldDto} from "../../../../../../model/dto/entity/ei-structure-field.dto";


@Component({
    selector: 'ei-structure-field-full',
    templateUrl: 'ei-structure-field-full.component.html',
    standalone: false
})
export class EiStructureFieldFullComponent extends EiStructureFieldBaseComponent implements OnInit {

    @Input() structureFieldDto: EiStructureFieldDto;

    ngOnInit() {
        super.ngOnInit();
    }

    get importTypeId(): number {
        return this.structureFieldDto?.importTypeDtoId;
    }

}
